__turbopack_context__.v({
  "userSuggestionTitle": "styles-module__uVxSeW__userSuggestionTitle",
});
